import axios from "axios";
import API from "../api";

export const TagsModule = {
  state: {
    tags: [],
    isRequesting: false,
    errored: false,
    error: "",
  },
  actions: {
    fetchTags({ commit }) {
      return new Promise(async (resolve, reject) => {
        commit("fetchTagsRequest");
        return axios
          .get(`${API.BASE_URL}${API.TAGS}`, API.RequestHeaders())
          .then((response) => {
            if (response.status === 200) {
              commit("fetchTagsSuccess", response.data);
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch((error) => {
            commit("tagError", error);
            reject(error);
          });
      });
    },
    createTag({ commit }, record) {
      return new Promise(async (resolve, reject) => {
        commit("createTagRequest");
        return axios
          .post(`${API.BASE_URL}${API.TAGS}`, record, API.RequestHeaders())
          .then((response) => {
            if (response.status === 201) {
              commit("createTagSuccess", response.data.original);
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch((error) => {
            commit("tagError", error);
            reject(error);
          });
      });
    },
    updateTag({ commit }, record) {
      return new Promise(async (resolve, reject) => {
        commit("updateTagRequest");
        return axios
          .put(
            `${API.BASE_URL}${API.TAGS}/${record.id}`,
            record,
            API.RequestHeaders()
          )
          .then((response) => {
            if (response.status === 200) {
              commit("updateTagSuccess", response.data.original);
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch((error) => {
            commit("tagError", error);
            reject(error);
          });
      });
    },
    deleteTag({ commit }, recordId) {
      return new Promise(async (resolve, reject) => {
        commit("deleteTagRequest");
        return axios
          .delete(
            `${API.BASE_URL}${API.TAGS}/${recordId}`,
            API.RequestHeaders()
          )
          .then((response) => {
            if (response.status === 200) {
              commit("deleteTagSuccess", recordId);
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch((error) => {
            commit("tagError", error);
            reject(error);
          });
      });
    },
  },
  mutations: {
    fetchTagsRequest(state) {
      state.isRequesting = true;
    },
    fetchTagsSuccess(state, payload) {
      state.tags = payload;
      state.isRequesting = false;
    },
    createTagRequest(state) {
      state.isRequesting = true;
    },
    createTagSuccess(state, payload) {
      state.tags.push(payload);
      state.isRequesting = false;
    },
    updateTagRequest(state) {
      state.isRequesting = true;
    },
    updateTagSuccess(state, payload) {
      const index = state.tags.findIndex((tag) => tag.id === payload.id);
      if (index !== -1) {
        state.tags.splice(index, 1, payload);
      }
      state.isRequesting = false;
    },
    tagError(state, error) {
      state.isRequesting = false;
      state.errored = true;
      state.error = error.message;
    },
    deleteTagRequest(state) {
      state.isRequesting = false;
    },
    deleteTagSuccess(state, recordId) {
      const deletedRecord = state.tags.find((tag) => tag.id === recordId);
      const currentIndex = state.tags.indexOf(deletedRecord);
      state.tags.splice(currentIndex, 1);
      state.isRequesting = false;
    },
  },
  getters: {
    getTags(state) {
      return state.tags;
    },
  },
};
